import PropTypes from "prop-types"
import * as Screens from "../screens"

export const CodeTableEntryShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  titleDe: PropTypes.string,
  titleFr: PropTypes.string,
  titleIt: PropTypes.string,
  titleEn: PropTypes.string,
})

export const CodeTableShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(CodeTableEntryShape).isRequired,
})

export const PictureShape = PropTypes.shape({
  base64: PropTypes.string.isRequired,
  drawingData: PropTypes.any,
  timestamp: PropTypes.number.isRequired,
})

export const DamageCaseIdShape = PropTypes.string

export const ACCOUNTING_HINT_CODES = ["INSURANCE", "MAINTENANCE", "PROPERTY", "HOUSE", "UNIT"]
export const ACCOUNTING_HINT_CODES_BY_LEVEL = {
  property: ["INSURANCE", "MAINTENANCE", "PROPERTY"],
  house: ["INSURANCE", "MAINTENANCE", "HOUSE"],
  unit: ["INSURANCE", "MAINTENANCE", "UNIT"],
}
export const CONTACT_ADDRESS_CODES = ["CARETAKER", "CURRENT_TENANT", "NEXT_TENANT", "CLERK"]
export const DELIVERY_ADDRESS_CODES = [
  "CARETAKER",
  "CURRENT_TENANT",
  "NEXT_TENANT",
  "DELIVERY_TO_HOUSE",
  "DELIVERY_TO_PROPERTY",
]
export const DAMAGE_TYPES = ["DAMAGE", "DEFECT"]

export const DamageCaseShape = PropTypes.shape({
  accountingHintCode: PropTypes.oneOf(ACCOUNTING_HINT_CODES),
  capOnExpenses: PropTypes.number,
  contactAddressCode: PropTypes.oneOf(CONTACT_ADDRESS_CODES),
  damageType: PropTypes.oneOf(DAMAGE_TYPES),
  deliveryAddressCode: PropTypes.oneOf(DELIVERY_ADDRESS_CODES),
  lhoRef: PropTypes.string.isRequired,
  passingCosts: PropTypes.bool,
  pictures: PropTypes.arrayOf(PictureShape.isRequired).isRequired,
  text: PropTypes.string,
  tradeCodes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  wrapperTextCode: PropTypes.string,
})

export const FeatureStateShape = PropTypes.shape({
  screen: PropTypes.oneOf(Screens.any),
  focusedPictureNr: PropTypes.number,
  unsentCases: PropTypes.objectOf(DamageCaseShape.isRequired).isRequired,
})



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/shapes.js